import { render } from "./RecieversGroupAddComponent.vue?vue&type=template&id=adc0c69e&scoped=true"
import script from "./RecieversGroupAddComponent.vue?vue&type=script&lang=js"
export * from "./RecieversGroupAddComponent.vue?vue&type=script&lang=js"

import "./RecieversGroupAddComponent.vue?vue&type=style&index=0&id=adc0c69e&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc0c69e"]])

export default __exports__